import React, { useRef, useState, useEffect } from 'react';
import { Menu, MenuItem, IconButton } from '@one-thd/sui-atomic-components';
import { More } from '@one-thd/sui-icons';
import { ON_CLOSE_MEATBALLS } from '../../../constants/custom-events';
import styles from './meatballs-menu.module.scss';
export const MeatballsMenu = ({ label, items, MenuProps, iconSize, }) => {
    const menuBtnRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    useEffect(() => {
        const listener = () => {
            setIsMenuOpen(false);
        };
        if (isMenuOpen) {
            // Custom event to close meatballs after PayPal handlers
            document.addEventListener(ON_CLOSE_MEATBALLS, listener);
        }
        return () => {
            document.removeEventListener(ON_CLOSE_MEATBALLS, listener);
        };
    }, [isMenuOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { icon: More, ref: menuBtnRef, onClick: () => {
                setIsMenuOpen(!isMenuOpen);
            }, role: "combobox", "aria-label": `Edit ${label}`, "aria-expanded": isMenuOpen, "aria-controls": `edit${label}Menu`, "aria-haspopup": "listbox", "data-testid": "meatballButton", iconSize: iconSize }),
        React.createElement("div", { className: "sui-font-regular sui-text-base sui-leading-tight sui-px-3 sui-whitespace-nowrap" },
            React.createElement(Menu, Object.assign({ id: `edit${label}Menu`, placement: "bottom-end", open: isMenuOpen, anchorEl: menuBtnRef.current, onClose: () => {
                    setIsMenuOpen(false);
                } }, MenuProps), items.map(({ value, isHidden, isDisabled, payPalBtn, action, dataTestId, }) => {
                return (!isHidden && (React.createElement(MenuItem, { "data-testid": dataTestId, key: value, value: value, disabled: isDisabled, onClick: () => {
                        if (!payPalBtn) {
                            setIsMenuOpen(false);
                        }
                        action();
                    } },
                    value,
                    payPalBtn && (React.createElement("div", { className: styles.hiddenBtn }, payPalBtn)))));
            })))));
};
MeatballsMenu.displayName = 'MeatballsMenu';
